import alisonBaker from 'url:../assets/images/testimonials/alison-baker.webp';
import emmaReynolds from 'url:../assets/images/testimonials/emma-reynolds.webp';
import lucaMudrich from 'url:../assets/images/testimonials/luca-mudrich.webp';
import sarahKelly from 'url:../assets/images/testimonials/sarah-kelly.webp';

export interface Testimonial {
  id: number;
  avatar: string;
  name: string;
  username: string;
  text: string;
}

export const USER_TESTIMONIAL: Testimonial[] = [
  {
    id: 0,
    avatar: alisonBaker,
    name: 'Alison Baker',
    username: '@alison.baker',
    text: 'I love how miniPT keeps me consistent. The real-time feedback feels like having a trainer with me — even when I’m working out at home.',
  },
  {
    id: 1,
    avatar: emmaReynolds,
    name: 'Emma Reynolds',
    username: '@emmafitjourney',
    text: 'MiniPT helped me finally stay consistent with strength training. The clear cues and tracking keep me motivated every session.',
  },
  {
    id: 2,
    avatar: lucaMudrich,
    name: 'Luca Mudrich',
    username: '@lucamudrich',
    text: 'I started using miniPT to rebuild my routine after an injury. The form corrections are super helpful — I feel safer and stronger every week.',
  },
  {
    id: 3,
    avatar: sarahKelly,
    name: 'Sarah Kelly',
    username: '@sarahhkelly123',
    text: 'My goal was weight loss, and miniPT made the whole process feel manageable. Short, effective workouts + accountability = perfect combo.',
  },
];
